import {z} from 'zod';

export const JourneyParticipationStatusSchema = z.enum(['in-progress', 'completed']);
export type JourneyParticipationStatus = z.infer<typeof JourneyParticipationStatusSchema>;
